import { useMutation, useQueryClient } from '@tanstack/react-query';

import { equipmentImagesListKey } from '@components/modals/EditSensorGalleryModal/services/useEquipmentImagesListQuery';

import { hardwareOverviewDetailsKey } from '@pages/HardwareOverviewDetails/services/useHardwareOverviewDetailsQuery';

import { apiClient } from '@services/apiClient';
import { installationPointPhotosKey } from '@services/useInstallationPointPhotosQuery';
import { listByInstPointKey } from '@services/useListByInstPointQuery';

interface IParams {
  onError: () => void;
}

interface IData {
  sourceFrom: string;
  imageId: number;
}

const equipmentSensorDeletePhotoChangeFn = (data: IData) =>
  apiClient.delete(`${APP_API_URL_V2}fsd/installation-point/delete-installation-point-image`, { data });

export const useEquipmentSensorDeletePhotoMutation = ({ onError }: IParams) => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: equipmentSensorDeletePhotoChangeFn,
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: [listByInstPointKey()[0]] });
      queryClient.invalidateQueries({ queryKey: [hardwareOverviewDetailsKey()[0]] });
      queryClient.invalidateQueries({ queryKey: [installationPointPhotosKey()[0]] });
      queryClient.invalidateQueries({ queryKey: [equipmentImagesListKey()[0]] });
    },
    onError: () => {
      if (onError) onError();
    },
  });
};
